/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocMinusIcon16Regular = forwardRef('DocMinusIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.5 9.89a.625.625 0 0 0 0 1.25h4a.625.625 0 1 0 0-1.25h-4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 3.75A2.75 2.75 0 0 1 4.75 1h3.597c.464 0 .91.184 1.237.513l2.904 2.903c.328.328.512.773.512 1.237v6.597A2.75 2.75 0 0 1 10.25 15h-5.5A2.75 2.75 0 0 1 2 12.25v-8.5ZM4.75 2.5c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-5.5h-3c-.69 0-1.25-.56-1.25-1.25v-3h-2.5Zm4 .3 2.45 2.45H8.75V2.8Z" })));
});
